import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, MapPin, Shield } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-[#0A0A0C] border-t border-[rgba(255,255,255,0.06)]" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2 space-y-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#E02852] flex items-center justify-center">
                <span className="font-serif text-xl font-semibold text-white">B</span>
              </div>
              <div>
                <span className="font-serif text-xl text-[#F7F6F2] tracking-tight">
                  Brothel Jobs Melbourne
                </span>
              </div>
            </div>
            
            <p className="text-[#A1A1AA] leading-relaxed max-w-md">
              Your guide to adult entertainment careers in Melbourne. 
              Professional, confidential, and compliant with Victoria's 
              Sex Work Decriminalisation Act.
            </p>

            {/* Contact Info */}
            <div className="space-y-3">
              <a
                href="sms:0429085683"
                className="flex items-center gap-3 text-[#F7F6F2] hover:text-[#E02852] transition-colors"
                data-testid="footer-sms"
              >
                <MessageCircle size={18} />
                <span>SMS Lisa: 0429 085683</span>
              </a>
              <div className="flex items-center gap-3 text-[#A1A1AA]">
                <MapPin size={18} />
                <span>Melbourne, VIC, Australia</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-mono text-xs text-[#E02852] tracking-[0.2em] uppercase mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Legal Framework', href: '#chapter-01' },
                { label: 'Earnings', href: '#chapter-02' },
                { label: 'Venues', href: '#chapter-03' },
                { label: 'Safety & Rights', href: '#chapter-04' },
                { label: 'Getting Started', href: '#chapter-05' },
                { label: 'FAQ', href: '#faq' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-[#A1A1AA] hover:text-[#F7F6F2] transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Apply */}
          <div>
            <h4 className="font-mono text-xs text-[#E02852] tracking-[0.2em] uppercase mb-6">
              Apply Now
            </h4>
            <p className="text-[#A1A1AA] text-sm mb-4">
              Ready to explore opportunities? Get in touch confidentially.
            </p>
            <a
              href="#contact"
              onClick={(e) => scrollToSection(e, '#contact')}
              className="inline-flex items-center gap-2 btn-primary px-5 py-2.5 rounded-full text-sm font-medium"
              data-testid="footer-apply-btn"
            >
              Apply Confidentially
            </a>

            {/* Compliance Badge */}
            <div className="mt-6 flex items-center gap-2 text-xs text-[#71717A]">
              <Shield size={14} className="text-[#22C55E]" />
              <span>Decriminalisation Act Compliant</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[rgba(255,255,255,0.06)]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-[#71717A]">
            <p>© {currentYear} Brothel Jobs Melbourne. All rights reserved.</p>
            <div className="flex items-center gap-6">
              <span>SMS only — no direct calls</span>
              <span className="text-[#A1A1AA]">Melbourne, VIC</span>
            </div>
          </div>
        </div>
      </div>

      {/* Emergency Resources Notice */}
      <div className="bg-[#121216] border-t border-[rgba(255,255,255,0.06)]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4">
          <p className="text-xs text-[#71717A] text-center">
            For emergency support services: Lifeline 13 11 14 | 1800RESPECT 1800 737 732
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
